<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <label class="col-form-label">Filter</label>
        <input
          type="text"
          class="form-control"
          placeholder="ID, First Name, Last Name, or Email Address"
          :value="filter"
          @keyup="e => onFilterValueChanged('filter', e.target.value)"
        />
      </div>
      <div class="col">
        <label class="col-form-label">Keyword Search</label>
        <input
          type="text"
          class="form-control"
          placeholder="Intimate partner abuse, child rape, disabled, etc."
          :value="keywords"
          @keyup="e => onFilterValueChanged('keywords', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">Gender</label>
        <select
          class="form-control"
          :value="gender"
          @change="e => onFilterValueChanged('gender', e.target.value)"
        >
          <option>All</option>
          <option value="m">Male</option>
          <option value="f">Female</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div class="col">
        <label class="col-form-label">State</label>
        <select
          class="form-control"
          :value="state"
          @change="e => onFilterValueChanged('state', e.target.value)"
        >
          <option>All</option>
          <option>Alabama</option>
          <option>Alaska</option>
          <option>Arizona</option>
          <option>Arkansas</option>
          <option>California</option>
          <option>Colorado</option>
          <option>Connecticut</option>
          <option>Delaware</option>
          <option>D.C.</option>
          <option>Florida</option>
          <option>Georgia</option>
          <option>Hawaii</option>
          <option>Idaho</option>
          <option>Illinois</option>
          <option>Indiana</option>
          <option>Iowa</option>
          <option>Kansas</option>
          <option>Kentucky</option>
          <option>Louisiana</option>
          <option>Maine</option>
          <option>Maryland</option>
          <option>Massachusetts</option>
          <option>Michigan</option>
          <option>Minnesota</option>
          <option>Mississippi</option>
          <option>Missouri</option>
          <option>Montana</option>
          <option>Nebraska</option>
          <option>Nevada</option>
          <option>New Hampshire</option>
          <option>New Jersey</option>
          <option>New Mexico</option>
          <option>New York</option>
          <option>North Carolina</option>
          <option>North Dakota</option>
          <option>Ohio</option>
          <option>Oklahoma</option>
          <option>Oregon</option>
          <option>Pennsylvania</option>
          <option>Rhode Island</option>
          <option>South Carolina</option>
          <option>South Dakota</option>
          <option>Tennessee</option>
          <option>Texas</option>
          <option>Utah</option>
          <option>Vermont</option>
          <option>Virginia</option>
          <option>Washington</option>
          <option>West Virginia</option>
          <option>Wisconsin</option>
          <option>Wyoming</option>
        </select>
      </div>
      <div class="col">
        <label class="col-form-label">Age</label>
        <select
          class="form-control"
          :value="age"
          @change="e => onFilterValueChanged('age', e.target.value)"
        >
          <option>All</option>
          <option value="12-">12 years old or younger</option>
          <option value="12-17">12-17 years old</option>
          <option value="18-24">18-24 years old</option>
          <option value="25-34">25-34 years old</option>
          <option value="35-44">35-44 years old</option>
          <option value="45-54">45-54 years old</option>
          <option value="55-64">55-64 years old</option>
          <option value="65-74">65-74 years old</option>
          <option value="-75">75 years old or older</option>
        </select>
      </div>
      <div class="col">
        <label class="col-form-label">Military Service</label>
        <select
          class="form-control"
          :value="militaryService"
          @change="e => onFilterValueChanged('militaryService', e.target.value)"
        >
          <option>All</option>
          <option value="true">Has served</option>
          <option value="false">Has not served</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "filters",
  props: {
    filter: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    keywords: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    gender: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    state: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    age: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    militaryService: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    },
    onFilterValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
